/**
 * Formats a number as currency with dot as thousands separator and no decimal places
 * @param {number} price - The price to format
 * @returns {string} - Formatted price string
 */
export const formatPrice = (retailPrice) => {
  if (retailPrice === undefined || retailPrice === null) return "0";

  // Round to nearest integer
  const roundedPrice = Math.round(retailPrice);

  // Convert to string
  const priceStr = roundedPrice.toString();

  // Add thousands separators
  return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};